import Footer from "./Footer.presenter";
export default Footer;
